/*
 * 系统参数代码
 */
export const SysParamCodes = {
    // --------- 认证 ( verify ) ----------
    // 1、供应商注册要求的资质代码 {String}
    VENDOR_REGIST_QUALIFY_CODE: "vendor.regist.qualify.code",

    // 2、零售商注册要求的资质代码 {String}
    RETAILER_REGIST_QUALIFY_CODE: "retailer.regist.qualify.code",

    // 3、服务商注册要求的资质代码 {String}
    SERVICER_REGIST_QUALIFY_CODE: "servicer.regist.qualify.code",

    // 设备导入模板文件地址：{String}
    DEVICE_IMPORT_TEMPLATE_FILE_URL: "device.import.template.file.url"
};

/*
 * 控制参数代码
 */
export const CtrlParamCodes = {
    // --------- 支付退款设置 ( pay.ctrl ) ----------

    // 1、是否可以线下付款：{Boolean} //适用于：零售商
    CAN_DO_PAY_OFFLINE: "can.do.pay.offline",
    // 1、是否可以线下退款：{Boolean} //适用于：供应商、服务商
    CAN_DO_REFUND_OFFLINE: "can.do.refund.offline",

    // --------- 佣金控制设置 ( yj.ctrl ) ----------

    // 1、佣金欠费是否显示后台提醒：{Boolean} //适用于： 供应商、服务商
    YJ_OVERDUE_SHOW_BACK_WARN: "yj.overdue.show.back.warn",
    // 1、佣金欠费是否显示前台提醒：{Boolean} //适用于： 供应商、服务商
    YJ_OVERDUE_SHOW_FRONT_WARN: "yj.overdue.show.front.warn",

    // 2、佣金欠费是否阻止报盘：{Boolean} //适用于：供应商、服务商
    YJ_OVERDUE_STOP_REPLY_DEAL: "yj.overdue.stop.reply.deal",
    // 2、佣金欠费是否阻止报价：{Boolean} //适用于：供应商、服务商
    YJ_OVERDUE_STOP_REPLY_PRICE: "yj.overdue.stop.reply.price",
    // 2、佣金欠费是否阻止投标：{Boolean} //适用于：供应商、服务商
    YJ_OVERDUE_STOP_TEND_BID: "yj.overdue.stop.tend.bid",
    // 2、佣金欠费是否阻止相应服务请求：{Boolean} //适用于：供应商、服务商
    YJ_OVERDUE_STOP_REPLY_SERVC_REQUEST: "yj.overdue.stop.reply.servc.request",

    // --------- 业务控制设置 ( biz.ctrl ) ----------

    // 1、遗留（老）合同录入时限（自入驻之日起 ）：{Integer} 天以内 //适用于： 零售商、供应商、服务商
    LEGACY_CONTRACT_REGIST_LIMIT_DAYS: "legacy.contract.regist.limit.days",

    // 2、是否允许设置设备的默认服务商：{Boolean} //适用于： 零售商
    ALLOW_SET_DEVICE_DEFAULT_SERVICER: "allow.set.device.default.servicer",

    // --------- Vip特性控制设置 ( vip.feature ) ----------

    // (创建)2级组织机构（公司）所需vip级别：{Single} //适用于供应商/服务商/零售商
    VIP_VALVE_FOR_ORG_LEVEL_2: "vip.valve.for.org.level.2",
    // (创建)3级组织机构（公司）所需vip级别：{Single} //适用于供应商/服务商/零售商
    VIP_VALVE_FOR_ORG_LEVEL_3: "vip.valve.for.org.level.3",
    // (创建)4级组织机构（公司）所需vip级别：{Single} //适用于供应商/服务商/零售商
    VIP_VALVE_FOR_ORG_LEVEL_4: "vip.valve.for.org.level.4",

    // 平台零售商系统三级域名支持所需vip级别：{Single} //适用于供应商/服务商
    VIP_VALVE_FOR_PLAT_SUBDOMAIN: "vip.valve.for.plat.subdomain",

    // 商户系统独立域名支持所需vip级别：{Single} //适用于供应商/服务商/零售商 暂时支持不了
    //  VIP_VALVE_FOR_SELF_PUBDOMAIN : "vip.valve.for.self.pubdomain",

    // 基于合同的站内信发送支持所需vip级别：{Single} //适用于供应商/服务商/零售商
    VIP_VALVE_FOR_CONTRACT_SITE_MSG: "vip.valve.for.contract.site.msg",

    // 对于合同阶段性进度监控支持所需vip级别：{Single} //适用于供应商/服务商/零售商
    VIP_VALVE_FOR_CONTRACT_PHASE_TRACK: "vip.valve.for.contract.phase.track"
};

/** 消息单据类型 */
export function getVoucherTypes() {
    return {
        "notice": "通知",
        "staff.quali": "人员资质",
        "servc.work": "服务工单",
        "servc.order": "服务订单",
        "price.reply": "报价单",
        "tend.bid": "投标书",
        "contract": "合同",
        "goods.ship": "发货单",
        "goods.recv": "收货单",
    };
}




//////////////////
// WEBPACK FOOTER
// ./src/app.const.js
// module id = 101
// module chunks = 1